import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  paginationContainer: {
    justifyContent: "end",
    marginTop: "10px"
  },
  threadsInput: {
    width: "80px",
    marginLeft: "10px"
  },
  updateButton: {
    alignItems: "center",
    minWidth: "51px"
  },
  iconContainer: {
    marginRight: "-8px"
  },
  iconButton: {
    padding: "0px",
  },
  threadInput: {
    minWidth: "240px"
  }
}))